import { Divider } from 'primereact/divider'
import { React } from 'react'
import { FooterDetail } from '../../static/config'

const Footer = () => {
  return (
    <div className="p-grid p-d-flex p-ai-center p-mt-5">
      <Divider />
      <div className="p-col-12 p-sm-9">
        <small>
          <a href={FooterDetail.link} target='_blank' rel="noreferrer">© {FooterDetail.company}</a>
          &nbsp;{FooterDetail.year} | p.iva {FooterDetail.piva}
        </small>
      </div>
      <div className="p-col-12 p-sm-3 p-text-right">
        <small>versione {FooterDetail.version}</small>
      </div>
    </div>
  )
}

export default Footer
